<template>
  <TransitionGroup  
    name="toast"
    tag="div" 
    class="fixed bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-3 z-50 w-full">
    <ToastAlert 
      v-for="toast in toastAlerts" 
      :key="toast.id"
      :toastAlert="toast" 
      @close="toastAlertStore.initiateCloseToastAlert" 
      class="relative pointer-events-auto w-full px-4"/>    
  </TransitionGroup>
</template>

<script setup lang="ts">
import { useToastAlertStore } from '@/store/toast-alert/toast-alert.state'
import ToastAlert from './ToastAlert.vue';
import { storeToRefs } from "pinia";

const toastAlertStore = useToastAlertStore();
const { toastAlerts } = storeToRefs(toastAlertStore);
</script>
